import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
import _ from "lodash";

class ParkAddressSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        return `
            <div class="lta-park-address-search">
                ${this.renderManualEntryNote(rowData?.manualEntryNote)}
                <div class="u-mb-4">
                    ${this.renderInstructionLabel(rowData?.instructionText)}
                </div>
				<div class="lta-park-address-search-title u-hidden">${titleMarkup}</div>
                <div class="lta-park-address-search--address-form u-mb-2">
                    <div class="lta-park-address-search--park-name u-mb-3"></div>
                    <div class="lta-park-address-search--address-line1 u-mb-3"></div>
                    <div class="lta-park-address-search--address-line2 u-mb-3"></div>
                    <div class="lta-park-address-search--town u-mb-3"></div>
                    <div class="lta-park-address-search--postcode u-mb-3"></div>
                </div>
            </div>`;
	}
    renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
    renderManualEntryNote(note) {
        if (!note) {
            return '';
        }

        return `
            <div class="lta-park-address-search__note u-bg-background-blue u-rounded u-p-3 u-mb-4">
                <div class="u-flex u-gap-2">
                    <lta-icon sprite-icon="info" width="1.5rem" height="1.5rem"></lta-icon>
                    <div>
                        <p class="u-body2 u-fw-bold u-mb-1">${note.title || 'Please note:'}</p>
                        ${note.description ? `<p class="u-body2 u-mb-2">${note.description}</p>` : ''}
                        <button type="button" class="lta-park-address-search--return-link lta-btn lta-btn--link u-caption1 u-text-lta-blue u-p-0">
                            ${note.backLinkLabel || 'Return to venue search'}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }
	afterRender() { 
		this.parkAddressSearchElement = SelectorEngine.findOne('.lta-park-address-search', this.containerEl);
        this.parkAddressSearchForm = SelectorEngine.findOne('.lta-park-address-search--address-form', this.parkAddressSearchElement);
        this.parkAddressParkName = SelectorEngine.findOne('.lta-park-address-search--park-name', this.parkAddressSearchForm);
        this.parkAddressAddressLine1 = SelectorEngine.findOne('.lta-park-address-search--address-line1', this.parkAddressSearchForm);
        this.parkAddressAddressLine2 = SelectorEngine.findOne('.lta-park-address-search--address-line2', this.parkAddressSearchForm);
        this.parkAddressTown = SelectorEngine.findOne('.lta-park-address-search--town', this.parkAddressSearchForm);
        this.parkAddressPostcode = SelectorEngine.findOne('.lta-park-address-search--postcode', this.parkAddressSearchForm);
        this.returnToSearchButton = SelectorEngine.findOne('.lta-park-address-search--return-link', this.parkAddressSearchElement);
        if (this.returnToSearchButton) {
            EventHandler.on(this.returnToSearchButton, 'click', () => {
                this.data?.onReturnToSearch?.();
            });
        }
        this.addressObjects = [];
        this.addressObjects = [
            {
                inputElementData: this.parkAddressParkName,
                elementDataKey: 'venueName'
            },
            {
                inputElementData: this.parkAddressAddressLine1,
                elementDataKey: 'addressLine1'
            },
            {
                inputElementData: this.parkAddressAddressLine2,
                elementDataKey: 'addressLine2'
            },
            {
                inputElementData: this.parkAddressTown,
                elementDataKey: 'county'
            },
            {
                inputElementData: this.parkAddressPostcode,
                elementDataKey: 'postcode'
            },
        ];
        this.initInputObject();
	}
    initInputObject() {
        let parkSearchAddressObject = {};
        for (const addressObject of  this.addressObjects) {
            const inputFieldObject = new InputField(addressObject.inputElementData, {
                data: this.data[addressObject.elementDataKey]
            });
            addressObject.inputElement = inputFieldObject;
            inputFieldObject.onChange((dataObject) => {
                const trimmedValue =
                    typeof dataObject.value === 'string' ? dataObject.value.trim() : dataObject.value;
                addressObject.value = trimmedValue;

                if (trimmedValue?.length > 2) {
                    parkSearchAddressObject = {
                        ...parkSearchAddressObject,
                        [addressObject.elementDataKey]: trimmedValue,
                        address: parkSearchAddressObject.address || {
                            street: null,
                            city: null,
                            state: null
                        }
                    };
                } else {
                    delete parkSearchAddressObject[addressObject.elementDataKey];
                }

                if (_.size(parkSearchAddressObject) === (this.addressObjects?.length + 1)) {
                    this.value = {
                        ...this.value,
                        ...this.prepareAddressObject(parkSearchAddressObject)
                    };
                } else {
                    this.value = undefined;
                }
            });
        }
    }
    prepareAddressObject(parkObject) {
        const modifyObject = {
            "id": '',
            "venueName": parkObject.venueName,
            "county": '',
            "postcode": parkObject.postcode,
            "address": {
               "street": parkObject.addressLine1,
               "city":parkObject.addressLine2,
               "state":parkObject.county
            }
         };
         return modifyObject;
    }
	validate() {
        return this.addressObjects.every((inputElementObject) => inputElementObject.inputElement.validate());
	}
}
export default ParkAddressSearch;
